function envFlag(name, fallback = false) {
    const value = process.env[name];
    if (value === undefined) {
        return fallback;
    }

    return String(value).toLowerCase() === "1" || String(value).toLowerCase() === "true";
}

export const features = {
    messaging: envFlag("REACT_APP_FEATURE_MESSAGING_ENABLED", false),
};

export { MESSAGING_ENABLED } from "./messagingEnabled";
